module.exports = __webpack_public_path__ + "img/1080_08.25bb78c5.jpg";